import { formattedDate } from '@utils/formattedDate'
import normalizeImage from '@models/Image'

const normalizePostCard = ({
  image,
  category,
  title,
  excerpt,
  date,
  link,
  slug,
  type,
}) => {
  const normalizedData = {
    image: normalizeImage(image),
    category,
    title,
    excerpt,
    date: date ? formattedDate(date) : null,
    link: type
      ? type === 'damage'
        ? `/di-che-ramo-sei/educational-danni/${slug}`
        : `/di-che-ramo-sei/educational-vita/${slug}`
      : `blog/${link ? link : slug}`,
  }

  return normalizedData
}

export default normalizePostCard
